import {createRequestRefreshScheduler} from "../helpers/requestRefreshScheduler";

export const createTaxonomyCountRefreshScheduler = ({
    getIds,
    request,
    applyCounts,
    onError,
    delay = 1000,
}) => {
    return createRequestRefreshScheduler({
        delay,
        onError,
        request: () => {
            const ids = getIds();
            return ids.length ? request(ids) : [];
        },
        applyResult: applyCounts,
    });
};
